module.exports = function () { /* empty */ };



/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/core-js/library/modules/_add-to-unscopables.js
 ** module id = 1516
 ** module chunks = 0
 **/